import { createServerFn } from '@tanstack/react-start';
import _ from 'lodash';
import { z } from 'zod';

import { product_languages } from '#/content';

const fieldIdsSchema = z.array(
  z.object({
    id: z.string(),
    order: z.number().optional(),
  })
);

const listProductLanguagesSchema = z
  .object({
    fields: z
      .object({
        ids: fieldIdsSchema,
      })
      .optional(),
    limit: z.number().optional(),
  })
  .optional();

/**
 * List customer testimonials.
 *
 * @param data.fields (optional) fields to filter by.
 */
export const listProductLanguages = createServerFn({
  method: 'POST',
})
  .validator((payload: unknown) => listProductLanguagesSchema.parse(payload))
  .handler(async (ctx) => {
    return _.chain(product_languages)
      .filter((lang) => {
        if (ctx.data?.fields?.ids) {
          return ctx.data.fields.ids.some((field) => field.id === lang.id);
        }

        return true;
      })
      .map((lang) => {
        const meta = ctx.data?.fields?.ids?.find((field) => field.id === lang.id);

        if (!meta) {
          return null;
        }

        return {
          ...lang,
          ...meta,
        };
      })
      .compact()
      .sortBy('order', 'asc')
      .take(ctx.data?.limit ?? 16)
      .value();
  });

export type ProductLanguage = Awaited<ReturnType<typeof listProductLanguages>>[number];
